import React, { Component } from 'react';
import Lander from './DestiLander';
import Section from './Section';
import '../css/style.css.scss';
import { segmentTrackEvent, scrollToTopOf } from '../utils';

class Destination extends Component {
  constructor() {
    super();
    this.state = {
      showSection: false,
      sectionIndex: null,
      showSectionButtons: false,
    };
    this.handleClick = this.handleClick.bind(this);
    this.scrollToSectionButtons = this.scrollToSectionButtons.bind(this);
  }

  handleClick(i, toggle) {
    this.setState({ sectionIndex: i });
    if (toggle) {
      this.setState({ showSection: !this.state.showSection });
    }
    window.scrollTo(0, 0);
  }

  scrollToSectionButtons() {
    this.setState({ showSectionButtons: !this.state.showSectionButtons });
    scrollToTopOf(document.getElementById('scroll-here'), 55);
  }

  render() {
    // the shape of the destructured this.props object will match the shape of the object in destination-data.js
    const {
      id,
      lander,
      sections,
      isMobile,
    } = this.props;
    const { showSectionButtons } = this.state;

    const renderedSectionHeads = sections.map((section, i) => {
      const sectionClass = `section-hed-container ${section.type}-hed`;
      const sectionHedClass = `section-hed ${section.type}-hed `;
      const sectionBtnClass = `section-button plus section-${i}`;
      const sectionHed = isMobile ? section.hed.mobile : section.hed.desktop;
      const sectionTracker = {
        module: 'Destination',
        category: 'open-section',
        linkType: 'open-section',
        label: `open-${section.type}-from-lander`,
      };
      return (
        <div className={sectionClass} key={i}>
          <img src={section.icon} className="section-hed-icon"></img>
          <h2 className={sectionHedClass} dangerouslySetInnerHTML={{ __html: sectionHed }} onClick={() => { segmentTrackEvent('article_clicked', sectionTracker); this.handleClick(i, true); }}></h2>
          <div className={sectionBtnClass} onClick={() => { segmentTrackEvent('section_button_clicked', sectionTracker); this.handleClick(i, true); }}></div>
        </div>
      );
    });

    const renderedSections = sections.map((section, i) => (
        <Section
          key={i}
          section={section}
          sectionIndex={i}
          type={section.type}
          handleClick={this.handleClick}
          isMobile={isMobile} />
    ));

    return (
      <div id={id}>
        {this.state.showSection
          ? 
          renderedSections[this.state.sectionIndex]
          : 
          <div>
            <Lander {...lander} renderedSectionHeads={renderedSectionHeads} showSectionButtons={this.state.showSectionButtons} onButtonClick={this.scrollToSectionButtons} isMobile={isMobile} />
            {/* sectionHeads for mobile rendered from here */}
            <div id="scroll-here"/>
            {/* {(isMobile && showSectionButtons === 'true') && { renderedSectionHeads }} */}
            {isMobile && renderedSectionHeads}
          </div>
        }
      </div>
    );
  }
}

export default Destination;
